import { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getConfigOptions } from '../../api/generated-evs/@tanstack/react-query.gen';
import LoadingBackdrop from '../../components/LoadingBackdrop';

export interface AppConfig {
  linuxBoxUrl: string;
}

const ConfigContext = createContext<AppConfig | null>(null);

export function ConfigProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useQuery(getConfigOptions());

  // Block children from rendering until the runtime config is loaded, so the
  // app always runs against the same URLs as the backend. Mirrors AuthProvider.
  if (isLoading) {
    return <LoadingBackdrop isLoading />;
  }

  return <ConfigContext.Provider value={{ linuxBoxUrl: data?.linuxBoxUrl ?? '' }}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) throw new Error('useConfig must be used within ConfigProvider');
  return context;
};
